import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../firebase/firebase";
import "./styles/Login.css";

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        throw new Error("Invalid email format");
      }
      if (form.password.length < 8) {
        throw new Error("Password must be at least 8 characters long");
      }

      const email = form.email.toLowerCase(); // Normalize email to lowercase
      console.log("Attempting to sign in with:", email);
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        form.password
      );
      await userCredential.user.getIdToken(true); // 🔁 force token refresh
      console.log("Firebase Auth successful, user:", userCredential.user.uid);


      const userDoc = await getDoc(doc(db, "users", email));
      console.log("User document exists:", userDoc.exists());

      if (!userDoc.exists()) {
        // Create new user document
        await setDoc(doc(db, "users", email), {
          email: email,
          displayName: userCredential.user.displayName || "Admin User",
          role: "admin",
          createdAt: new Date(),
          lastLogin: new Date(),
          uid: userCredential.user.uid,
        });
      } else {
        // Update existing user document
        await updateDoc(doc(db, "users", email), {
          lastLogin: new Date(),
        });
      }

      console.log("Login successful, navigating to admin page");
      navigate("/admin/blog");
    } catch (err: any) {
      console.error("Login error:", err);
      console.error("Error code:", err.code);
      console.error("Error message:", err.message);

      if (err.code === "auth/user-not-found") {
        setError("No account found with this email.");
      } else if (err.code === "auth/wrong-password") {
        setError("Incorrect password.");
      } else if (err.code === "auth/too-many-requests") {
        setError("Too many failed attempts. Please try again later.");
      } else if (err.message === "Invalid email format") {
        setError("Please enter a valid email address.");
      } else if (
        err.message === "Password must be at least 8 characters long"
      ) {
        setError("Password must be at least 8 characters long.");
      } else {
        setError("An error occurred. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h1>Admin Login</h1>
      <form onSubmit={handleSubmit}>
        <input
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
          autoComplete="email"
        />
        <input
          name="password"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
          autoComplete="current-password"
          minLength={8}
        />
        <button type="submit" disabled={loading}>
          {loading ? "Signing in..." : "Login"}
        </button>
        {error && <p className="error-message">{error}</p>}
      </form>
    </div>
  );
}
